import type {
  KnowledgeFeedFetchForTopicAction,
  KnowledgeFeedFetchForTopicFailureAction,
  KnowledgeFeedFetchForTopicPayload,
  KnowledgeFeedFetchForTopicSuccessAction,
} from "entities/knowledgeFeed/actionTypes";
import { KnowledgeFeedActionTypes } from "entities/knowledgeFeed/actionTypes";

export const fetchKnowledgeFeedForTopic = (
  payload: KnowledgeFeedFetchForTopicPayload,
): KnowledgeFeedFetchForTopicAction => ({
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC,
  payload,
});

export const fetchKnowledgeFeedForTopicSuccess = (
  payload: KnowledgeFeedFetchForTopicSuccessAction["payload"],
  meta: KnowledgeFeedFetchForTopicSuccessAction["meta"],
): KnowledgeFeedFetchForTopicSuccessAction => ({
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchKnowledgeFeedForTopicFailure = (
  meta: KnowledgeFeedFetchForTopicFailureAction["meta"],
): KnowledgeFeedFetchForTopicFailureAction => ({
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC_FAILURE,
  meta,
});
